import React from 'react';
import { SectionHeading } from '../ui/SectionHeading';
import { Reveal } from '../ui/Reveal';
import { INDUSTRIES } from '../../data/content';
import { IMAGES } from '../../data/images';
import { useLanguage } from '../../i18n/LanguageContext';
export function Industries() {
  const {
    lang,
    t
  } = useLanguage();
  return <section className="relative w-full overflow-hidden bg-navy-950 py-24 lg:py-32" data-id="element-136" data-mp="fo0xjiqxedj3">
      <img src={IMAGES.network} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-40" data-id="element-137" data-mp="3o1rh0tlosvlx" />
      <div className="absolute inset-0 bg-gradient-to-b from-navy-950 via-navy-950/85 to-navy-950" aria-hidden="true" data-id="element-138" data-mp="xtnnrezi2u0" />
      <div className="relative mx-auto max-w-container px-6" data-id="element-139" data-mp="3s3352uowx8s0">
        <SectionHeading eyebrow={t.industries.eyebrow} title={t.industries.title} description={t.industries.description} align="center" tone="light" data-id="element-140" data-mp="1ccqff92jz652" />

        <ul className="mt-16 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4" data-id="element-141" data-mp="2vnmzj7znusfd">
          {INDUSTRIES.map((industry, i) => <Reveal as="li" key={industry.name.en} delay={i * 0.04} data-id="element-142" data-mp="2zndvrr7yi0ra" data-mpi={i}>
              <div className="group flex h-full items-center gap-4 rounded-2xl border border-white/10 bg-white/[0.04] p-5 transition-all duration-300 hover:border-gold/40 hover:bg-white/[0.08]" data-id="element-143" data-mp="34na422nosecn">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-white/5 text-gold transition-colors duration-300 group-hover:bg-gold group-hover:text-navy" data-id="element-144" data-mp="2bzml0s22dvs4">
                  <industry.Icon className="h-4 w-4" aria-hidden="true" data-id="element-145" data-mp="2lxk83c86tmj5" />
                </span>
                <h3 className="text-sm font-medium leading-snug text-white" data-id="element-146" data-mp="2qnqvj8qyr0zt">
                  {industry.name[lang]}
                </h3>
              </div>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}